import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { SharedService } from '../services';

@Injectable()
export class AccessAuthGuard implements CanActivate {
    constructor(private router: Router, private sharedService: SharedService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url: string = state.url;
        if (this.sharedService.isHavingAccess(route.url)) {
            return true;
        }
        this.router.navigate(['/login']);
        return false;
    }
}